import { Path, UseFormReturn } from "react-hook-form";
import { TProductForm } from "@/api/services/main/organization/product/dtos/product.dto";
import { REFUND_ROW_COUNT } from "@/features/organization/product/constants/productEnums";
import { useBatchTriggerValidate } from "@/hooks/useTriggerValidate";

type TUseRefundConditionsTriggerValidateProps = {
  methods: UseFormReturn<TProductForm, object, TProductForm>;
};

const REFUND_TRIGGER_VALIDATE_PAIRS = Array.from({ length: REFUND_ROW_COUNT }, (_, i) => ([
  {
    name: `refundConditions.${i}.tenureMonths` as Path<TProductForm>,
    triggerFields: [`refundConditions.${i}.refundValue` as Path<TProductForm>],
  },
  {
    name: `refundConditions.${i}.refundValue` as Path<TProductForm>,
    triggerFields: [`refundConditions.${i}.tenureMonths` as Path<TProductForm>],
  },
])).flat();

/**
 * Revalidate only the changed refund cell that has actual cross-field constraints.
 * Scope is limited to tenureMonths / refundValue to avoid unnecessary trigger calls.
 */
export const useRefundConditionsTriggerValidate = ({ methods }: TUseRefundConditionsTriggerValidateProps) => {
  useBatchTriggerValidate({ methods, pairs: REFUND_TRIGGER_VALIDATE_PAIRS });
};
